import {serverSideTranslations} from "next-i18next/serverSideTranslations";
import HomeBanner from "../components/common/HomeBanner";
import Script from "next/script";
import {useTranslation} from "next-i18next";
import {ReactElement} from "react";
import Layout from "../components/common/Layout";

function Page() {
    const {t} = useTranslation();

    return (
        <>
            <div className=" bg-white max-w-[1480px] mx-auto font-lato mt-[200px] mb-8 px-6">
                <h3 className="mb-6 pl-1">Rentware</h3>
                <div className="w-full mb-8">
                    <HomeBanner showBtn={false} />
                </div>

                <Script
                    id="rtr-token"
                    strategy="beforeInteractive"
                    dangerouslySetInnerHTML={{
                    __html: `window.RTR_ACCESS_TOKEN = "W3aa1be393cc8ec21c4b2c2e8b116e35e";`,
                    }}
                />

                <Script
                    src="https://cdn.rtr-io.com/widgets.js"
                    type="module"
                    strategy="beforeInteractive"
                />

                <rtr-checkout></rtr-checkout>

                <rtr-search
                    view="default"
                    show-location="off"
                    load-behaviour="extended"
                    locations="0194413d-bb87-7c47-9d72-9c3a9ac30fb7"
                />
            </div>
        </>
    );
}

export async function getStaticProps({locale}: any) {
    return {
        props: {
            ...(await serverSideTranslations(locale, ["common"]))
        }
    };
}

Page.getLayout = function getLayout(page: ReactElement) {
	return (
		<Layout 
			headerNotTransparent={false}
			hasShadow={true}
		>
			{page}
		</Layout>
	);
};


export default Page;
